<ng-template #myTemplate2>
  <!-- #2 -->
  <div
    class="card card--2 card--yellow d-flex flex-column flex-lg-row-reverse justify-content-lg-between align-items-lg-center gap-3">
    <div class="card__img">
      <img class="img-fluid" [src]="'/assets/img/how-to-screen/paper.svg'"
        alt="A Type 1 Diabetes (T1D) doctor discussion guide" width="134" height="173" />
    </div>
    <div class="card__text d-flex flex-column gap-3 text-center text-lg-start">
      <h3 class="mb-0">Talk to your Doctor</h3>
      <p class="mb-0">
        Starting with your doctor is an important step to getting screened for
        type 1 diabetes. Your doctor could help you get tested at a
        participating lab or in office kit. This guide can help you with that
        conversation.
      </p>
      <!-- mobile -->
      <div class="btn d-lg-none px-0 py-0 mb-4" global-button [buttonData]="card2Button1"></div>
      <!-- desktop -->
      <div class="btn d-none d-lg-block px-0 py-0 mb-4" global-button [buttonData]="card2Button1Desk"></div>
      <p class="mb-0">
        Watch Adam Schefter play doctor and patient and show how he would ask to
        be screened.
      </p>
      <div class="btn px-0 py-0" global-button [buttonData]="card2Button2"></div>
    </div>
  </div>
</ng-template>

<ng-template #myTemplate3>
  <!-- #3 -->
  <div class="card card--3 card--orange d-flex flex-column gap-3">
    <!-- icon mobile only -->
    <div class="card__img d-lg-none mx-auto">
      <img class="img-fluid" [src]="'/assets/img/how-to-screen/microscope.svg'" alt="A microscope" width="113"
        height="113" />
    </div>
    <div class="card__text d-flex flex-column gap-4">
      <h3 class="text-center text-lg-start mb-0">Explore Research Programs</h3>
      <div class="research d-flex flex-column flex-lg-row">
        <div class="research__item">
          <div class="d-flex flex-lg-column gap-3 gap-lg-1">
            <div class="research__item__img--1 flex-shrink-0">
              <picture [data]=" {
          image: 'how-to-screen/ask-logo',
          altext: 'Autoimmunity Screening for Kids (ASK) logo',
          format: '',
          width: '96',
          height: '45',
          mobile: true,
          webp: true,
          classes: 'img-fluid w-100',
        }"></picture>
            </div>
            <p class="mb-0">
              Autoimmunity Screening for Kids (ASK) is an autoantibody test that
              is free to all children in the U.S.
            </p>
          </div>
          <!-- button only on desktop -->
          <div class="d-flex">
            <div class="btn px-0 py-0 mt-3" global-button [buttonData]="card3Button1"></div>
          </div>
        </div>
        <hr class="research__divider" />

        <div class="research__item">
          <div class="d-flex flex-lg-column gap-3 gap-lg-1">
            <div class="research__item__img--2 flex-shrink-0">
              <picture [data]=" {
            image: 'how-to-screen/trial-net-logo',
            altext: 'Type 1 Diabetes TrialNet logo',
            format: '',
            width: '70',
            height: '50',
            mobile: true,
            webp: true,
            classes: 'img-fluid w-100',
          }"></picture>
            </div>
            <p class="mb-0">
              If you have a relative with type 1 diabetes, TrialNet* can mail
              you a free test kit to be taken at home or at a participating lab.
            </p>
          </div>
          <!-- button only on desktop -->
          <div class="d-flex">
            <div class="btn px-0 py-0 mt-3" global-button [buttonData]="card3Button2"></div>
          </div>
        </div>
        <div class="card__img--desk d-none d-lg-block">
          <img class="img-fluid" [src]="'/assets/img/how-to-screen/microscope.svg'" alt="A microscope" width="186"
            height="186" />
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div container>
  <div class="how-can-screen d-flex flex-column">
    <div class="how-can-screen__header">
      <h2 class="mb-3">Get screened now</h2>
      <p class="mb-3">
        The American Diabetes Association recommends that high-risk individuals proactively screen for type 1 diabetes
        with a blood test that can detect it in the early stages.
      </p>
      <p class="mb-0">
        Screening may provide you information that allows you and your doctor to proactively manage your health—but it's
        important to act. If not screened early, life-threatening complications at diagnosis could seem to happen out of
        nowhere.
      </p>
    </div>

    <!-- #4 -->
    <div
      class="card card--4 card--purple d-flex flex-column flex-lg-row-reverse justify-content-lg-between align-items-lg-center gap-3">
      <div class="card__img">
        <img class="img-fluid" [src]="'/assets/img/how-to-screen/antibodies.svg'"
          alt="A magnifying glass looking at autoantibodies" width="194" height="194" />
      </div>
      <div class="card__text d-flex flex-column gap-3 text-center text-lg-start">
        <h3 class="mb-0">QuestHealth.com</h3>
        <p class="mb-0">
          With this on-demand option, you can directly request a Type 1 Diabetes
          Autoantibody Screening Test with Quest Diagnostics<sup>®</sup>.
        </p>
        <div class="btn px-0 py-0" global-button [buttonData]="card4Button1"></div>
      </div>
    </div>

    <ng-template *ngTemplateOutlet="myTemplate2"></ng-template>

    <ng-template *ngTemplateOutlet="myTemplate3"></ng-template>

    <!-- #1 -->
    <!-- <div
      class="card card--1 card--aqua d-flex flex-column flex-lg-row-reverse justify-content-lg-between align-items-lg-center gap-3"
    >
      <div class="card__img mx-auto">
        <img
          class="img-fluid"
          [src]="'/assets/img/how-to-screen/sc-logo.svg'"
          alt="Type 1 Diabetes Screening Central logo"
          width="313"
          height="105"
        />
      </div>
      <div
        class="card__text d-flex flex-column gap-3 text-center text-lg-start"
      >
        <div>
          <h3>Screening Central</h3>
          <p class="mb-0">
            Screening Central offers a comprehensive and convenient solution to
            help with every step of screening for type 1 diabetes
            autoantibodies.
          </p>
        </div>
        <div
          class="btn px-0 py-0"
          global-button
          [buttonData]="card1Button1"
        ></div>
      </div>
    </div> -->
  </div>
</div>